var i;!function(i){i[i.Uninitialized=0]="Uninitialized",i[i.Mint=1]="Mint",i[i.Account=2]="Account"}(i||(i={}));const n=1;export{n as ACCOUNT_TYPE_SIZE,i as AccountType};
//# sourceMappingURL=accountType.mjs.map
